'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHash = exports.getActionName = exports.isOtherType = undefined;

var _variables = require('./variables');

var _variables2 = _interopRequireDefault(_variables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isOtherType = function isOtherType(actionType) {
  return actionType === _variables2.default.keyOtherTypeOption;
};
var getActionName = function getActionName(actionType) {
  return actionType.split('.')[1];
};
var getHash = function getHash() {
  return Math.random().toString(36).substr(2, 9).toUpperCase();
};

exports.isOtherType = isOtherType;
exports.getActionName = getActionName;
exports.getHash = getHash;